import { Controller } from '@hotwired/stimulus'
import IMask from 'imask'

export default class ImaskController extends Controller {
  connect () {
    this.#initializeMask()
    if (this.mask) {
      this.mask.on('complete', () => this.dispatch('complete'))
    }
  }

  disconnect () {
    if (this.mask) {
      this.mask.off('complete')
      this.mask.destroy()
    }
  }

  #initializeMask () {
    const maskOptions = this.#getMaskOptions(this.element.dataset.type)
    if (maskOptions) {
      this.mask = new IMask(this.element, maskOptions)
    }

    if (!this.mask.unmaskedValue || this.mask.unmaskedValue === '') {
      this.mask.unmaskedValue = '0'
    }

    this.element.addEventListener('blur', () => {
      if (!this.mask.unmaskedValue || this.mask.unmaskedValue === '') {
        this.mask.unmaskedValue = '0'
      }
    })
  }

  #getMaskOptions (type) {
    switch (type) {
      case 'currency':
        return {
          mask: '$ num',
          blocks: {
            num: {
              mask: Number,
              min: 0,
              thousandsSeparator: ',',
              scale: 2,
              normalizeZeros: true,
              radix: '.',
              padFractionalZeros: true
            }
          }
        }
      case 'percent':
        return {
          mask: Number,
          min: 0,
          max: 100,
          thousandsSeparator: ',',
          radix: '.'
        }
      case 'phone':
        return {
          mask: '+1-000-000-0000'
        }
      case 'zip':
        return {
          mask: [
            '00000',
            '00000-0000'
          ]
        }
      case 'pixels':
        return {
          mask: 'numpx',
          lazy: false,
          blocks: {
            num: {
              mask: Number,
              min: 0,
              scale: 1,
              signed: false,
              radix: '.',
              normalizeZeros: true,
              padFractionalZeros: false
            }
          }
        }

      default:
        return null
    }
  }
}
